/* pamela-kiosk-photo-handoff.js
   Kiosk-only: replaces the local file/media picker for portrait photo
   uploads with a QR "send from your own phone" flow. Fully Kiosk's
   Advanced Kiosk Protection ("Disable Other Apps") blocks the native
   Android file-chooser intent that the normal <input type="file"> picker
   needs on the tablet, so the customer's own phone talks to the server
   directly instead -- no cable, no pairing, no app to install.

   Complete no-op unless sessionStorage.cm_kiosk_mode === "1" (only ever set
   by /pages/kiosk-welcome). See pamela-kiosk-mode.js for the flag pattern.
*/
(function () {
  const UPLOAD_HOST = "https://cm-editor-server.onrender.com";
  const POLL_MS = 2000;
  const SESSION_TIMEOUT_MS = 10 * 60 * 1000;
  const MODAL_ID = "pamela-kiosk-photo-handoff-modal";

  function isKioskActive() {
    try { return sessionStorage.getItem("cm_kiosk_mode") === "1"; } catch (_) { return false; }
  }

  function waitForPortraitUpload(cb) {
    if (
      window.CM_PortraitUpload &&
      window.CM_PortraitUpload.openPickerForWrapper &&
      window.CM_PortraitUpload.setPortraitImage &&
      window.CM_PortraitUpload.loadHtmlImage
    ) {
      cb();
    } else {
      setTimeout(function () { waitForPortraitUpload(cb); }, 150);
    }
  }

  function buildModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;
    modal = document.createElement("div");
    modal.id = MODAL_ID;
    modal.style.cssText = [
      "position:fixed", "inset:0", "z-index:99999", "background:rgba(18,18,18,.92)",
      "display:flex", "align-items:center", "justify-content:center",
      "flex-direction:column", "text-align:center", "color:#fff",
      "padding:24px", "box-sizing:border-box"
    ].join(";");
    modal.innerHTML =
      '<div style="max-width:420px;width:100%;">' +
        '<h2 style="margin:0 0 8px;font-size:1.4rem;">Scan to send your photo</h2>' +
        "<p style=\"color:#ccc;margin:0 0 20px;font-size:1rem;line-height:1.4;\">Open your phone's camera, point it at the code below, then choose a photo. It will show up here automatically.</p>" +
        '<div id="pamela-kiosk-photo-qr" style="background:#fff;padding:16px;border-radius:12px;display:inline-block;min-width:220px;min-height:220px;"></div>' +
        '<p id="pamela-kiosk-photo-status" style="margin-top:20px;font-size:.95rem;color:#ccc;">Getting things ready&hellip;</p>' +
        '<button id="pamela-kiosk-photo-cancel" style="margin-top:12px;padding:12px 24px;background:transparent;border:1px solid #666;color:#fff;border-radius:8px;font-size:1rem;">Cancel</button>' +
      "</div>";
    document.body.appendChild(modal);
    return modal;
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) modal.remove();
  }

  // Shows the existing "what makes a good photo" guidance modal (same one
  // the normal upload flow uses -- shared "portrait" scope, so it still only
  // shows once per page load either way), THEN opens the QR modal once the
  // customer taps through it.
  function openKioskPhotoHandoff(wrapper) {
    return new Promise((resolve) => {
      if (typeof window.CM_showOriginalUploadGuidanceOnce === "function") {
        window.CM_showOriginalUploadGuidanceOnce(
          function () { showQrModal(wrapper).then(resolve); },
          { scope: "portrait", title: "Before you upload a portrait photo", buttonText: "OK, choose photo" }
        );
      } else {
        showQrModal(wrapper).then(resolve);
      }
    });
  }

  function showQrModal(wrapper) {
    return new Promise((resolve) => {
      let cancelled = false;
      let pollTimer = null;

      const modal = buildModal();
      const qrBox = modal.querySelector("#pamela-kiosk-photo-qr");
      const statusEl = modal.querySelector("#pamela-kiosk-photo-status");
      const cancelBtn = modal.querySelector("#pamela-kiosk-photo-cancel");

      qrBox.innerHTML = '<div style="width:220px;height:220px;display:flex;align-items:center;justify-content:center;color:#999;">Loading&hellip;</div>';

      function stop(result) {
        if (pollTimer) clearInterval(pollTimer);
        closeModal();
        resolve(!!result);
      }

      cancelBtn.onclick = function () {
        cancelled = true;
        stop(false);
      };

      fetch(UPLOAD_HOST + "/api/photo-handoff/create", { method: "POST" })
        .then((r) => r.json())
        .then((data) => {
          if (cancelled) return;
          if (!data || !data.ok || !data.uploadUrl || !data.code) {
            statusEl.textContent = "Couldn't start photo transfer. Please tell Pamela.";
            statusEl.style.color = "#e07a7a";
            return;
          }

          const escapedUrl = String(data.uploadUrl).replace(/"/g, "&quot;");
          const qrSrc = "https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=" + encodeURIComponent(data.uploadUrl);
          const img = new Image();
          img.width = 220;
          img.height = 220;
          img.alt = "QR code";
          img.style.display = "block";
          img.onerror = function () {
            qrBox.innerHTML =
              '<div style="width:220px;color:#333;font-size:.85rem;word-break:break-all;">Go to:<br><b>' + escapedUrl + "</b></div>";
          };
          img.src = qrSrc;
          qrBox.innerHTML = "";
          qrBox.appendChild(img);
          statusEl.textContent = "Waiting for your photo…";

          const code = data.code;
          const startedAt = Date.now();

          pollTimer = setInterval(function () {
            if (cancelled) return;
            if (Date.now() - startedAt > SESSION_TIMEOUT_MS) {
              statusEl.textContent = "This code timed out. Tap Cancel and try again.";
              statusEl.style.color = "#e07a7a";
              clearInterval(pollTimer);
              return;
            }
            fetch(UPLOAD_HOST + "/api/photo-handoff/" + encodeURIComponent(code) + "/status")
              .then((r) => r.json())
              .then(async (sd) => {
                if (!sd || !sd.ok || cancelled) return;
                if (sd.status === "expired") {
                  statusEl.textContent = "This code expired. Tap Cancel and try again.";
                  statusEl.style.color = "#e07a7a";
                  clearInterval(pollTimer);
                  return;
                }
                if (sd.status === "done" && sd.url) {
                  clearInterval(pollTimer);
                  statusEl.textContent = "Got it! Adding your photo…";
                  statusEl.style.color = "#7fd67f";
                  try {
                    const hostedImg = await window.CM_PortraitUpload.loadHtmlImage(sd.url);
                    window.CM_PortraitUpload.setPortraitImage(wrapper, hostedImg, {
                      url: sd.url,
                      delete_token: sd.delete_token || "",
                      original_name: sd.original_name || "",
                      content_type: sd.content_type || "",
                      width: hostedImg.naturalWidth || 0,
                      height: hostedImg.naturalHeight || 0,
                      heic_ack: true
                    });
                    try {
                      const layer = wrapper.getLayer && wrapper.getLayer();
                      if (layer && layer.batchDraw) layer.batchDraw();
                      else if (layer && layer.draw) layer.draw();
                      else if (wrapper.getStage && wrapper.getStage()) wrapper.getStage().draw();
                    } catch (_) {}
                    // setPortraitImage() alone doesn't attach the draggable
                    // center handle -- normally that's done by a second
                    // wrapper around openPickerForWrapper (see
                    // CM_PortraitCenterHandle_MovePhoto), which this kiosk
                    // flow bypasses entirely. window.CM_resumePortraitEditing
                    // is the same global hook the "Fit Photo" button uses to
                    // (re)attach it, so call it explicitly here too.
                    try { window.CM_resumePortraitEditing && window.CM_resumePortraitEditing(wrapper, { select: true }); } catch (_) {}
                    try { setTimeout(function () { window.CM_DRAFTS_SAVE_NOW && window.CM_DRAFTS_SAVE_NOW(); }, 800); } catch (_) {}
                    stop(true);
                  } catch (err) {
                    statusEl.textContent = "Photo received but couldn't load it. Please try again.";
                    statusEl.style.color = "#e07a7a";
                  }
                }
              })
              .catch(function () {});
          }, POLL_MS);
        })
        .catch(function () {
          if (cancelled) return;
          statusEl.textContent = "Couldn't reach the server. Check the internet connection.";
          statusEl.style.color = "#e07a7a";
        });
    });
  }

  waitForPortraitUpload(function () {
    const original = window.CM_PortraitUpload.openPickerForWrapper;
    window.CM_PortraitUpload.openPickerForWrapper = function (wrapper) {
      if (!isKioskActive()) return original(wrapper);
      return openKioskPhotoHandoff(wrapper);
    };
  });
})();
